import React from 'react';
import Badge from '@amzn/awsui-components-core/badge';
import Popover from '@amzn/awsui-components-core/popover';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';

/** The "Suggested" badge shown wherever the profile returned a rule-based suggestion. The tooltip gives the reason. */
export const SuggestionBadge: React.FC<{ text: StarGridText; suggestion: string }> = ({ text, suggestion }) => (
  <Popover
    dismissButton={false}
    position="top"
    size="small"
    triggerType="custom"
    content={
      <>
        <strong>{suggestion}</strong>
        <div>{text('suggestedReason')}</div>
      </>
    }
  >
    <Badge color="blue">{text('suggested')}</Badge>
  </Popover>
);
